import { useCallback, useState } from 'react';

import { SubModule } from '@silvertours/common-landingpages-view';

import { Ui } from '@silvertours/front-shared';

export type TabsBehavior = {
  onTabSelected: (tabName: string) => void;
};

export type TabsRules = {
  textStyle?: Ui.RichTextStyle;
};

export type TabsProps = {
  behavior: TabsBehavior;
  content?: Pick<SubModule<unknown>, 'name' | 'position'>[];
  rules?: TabsRules;
  tabGroup: string;
};

export const Tabs = ({
  behavior: { onTabSelected },
  content,
  rules,
  tabGroup,
}: TabsProps) => {
  const initialName = content?.length ? content[0].name : '';
  const [activeTabName, setActiveTabName] = useState(initialName);

  const handleTabSelected = useCallback(
    (tabName: string) => {
      setActiveTabName(tabName);
      onTabSelected(tabName);

      // wait for the next event loop to ensure the tab panel is rendered
      setTimeout(() => {
        // focus active tab panel
        if (!tabGroup || !content) {
          return;
        }
        const position = content.find(tab => tab.name === tabName)?.position;
        const tabPanel = document.getElementById(
          `${tabGroup}-panel-${position}`,
        );
        if (tabPanel) {
          tabPanel.focus();
        }
      }, 0);
    },
    [content, tabGroup, onTabSelected],
  );

  if (!content || content.length === 0) {
    return null;
  }
  const { textStyle = Ui.RichTextStyle.Primary } = rules || {};

  return (
    <Ui.TabNavigation textStyle={textStyle}>
      {content.map(tab => (
        <Ui.TabButton
          behavior={{ onSelectTab: handleTabSelected }}
          content={{ ...tab, tabGroup }}
          key={tab.position}
          rules={{ activeTabName, textStyle }}
        />
      ))}
    </Ui.TabNavigation>
  );
};
